import { inject, Injectable } from '@angular/core';
import { Dialog, DialogConfig, DialogRef } from '@angular/cdk/dialog';
import { ComponentType, Overlay } from '@angular/cdk/overlay';
import { Intercom } from '../../../core/intercom/intercom';

@Injectable({
  providedIn: 'root'
})
export class DrawerService {
  private dialog = inject(Dialog);
  private overlay = inject(Overlay);
  private intercom = inject(Intercom);

  open<T>(component: ComponentType<T>, config?: DialogConfig): DialogRef<T> {
    this.intercom.update({ hide_default_launcher: true });
    const ref = this.dialog.open<T>(component, {
      ...config,
      restoreFocus: false,
      panelClass: ['milestone-dialog', 'animated', 'slideInRight', 'faster', 'h-100'],
      positionStrategy: this.overlay.position().global().top('0').bottom('0').right('0'),
      scrollStrategy: this.overlay.scrollStrategies.block(),
      disableClose: config?.disableClose ?? true
    });
    ref.closed.subscribe(_ => this.intercom.update({ hide_default_launcher: false }))
    return ref;
  }

  // For the looker dashboard dialog
  openBottomSheet(component: ComponentType<any>, config?: DialogConfig): DialogRef<any> {
    this.intercom.update({ hide_default_launcher: true });
    const ref = this.dialog.open(component, {
      data: config.data,
      hasBackdrop: false,
    });
    ref.closed.subscribe(_ => this.intercom.update({ hide_default_launcher: false }))
    return ref;
  }
}
